import { Component, PropSync, Vue } from "vue-property-decorator";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Reconciliation } from "@/constant";

// 列表 - 彙總
type GroupItem = {
  terminalNo: string;
  date: string;
  batchNo: string;
  count: number;
  amount: number;
  infoType: number;
};

@Component<LBtable>({
  components: {}
})
export default class LBtable extends Vue {
  // prop in
  @PropSync("tableType", { type: Number })
  syncedTableType!: number;

  @PropSync("batchNoTitle", { type: Object })
  syncedBatchNoTitle!: TCBReceiptApi.Protobuf.Reconciliation;

  // @PropSync("batchNoInfo", { type: [] })
  @PropSync("batchNoInfo")
  // syncedBatchNoInfo!: (TCBReceiptApi.Protobuf.ReimbursementInfo | GroupItem)[];
  syncedBatchNoInfo!: any;

  private transactionMap = Reconciliation.TransactionMap;
  
  // event out
  private close() {
    this.$emit("closeLBtable"); // 觸發的事件名稱
  }

  // inside
  private isNotNatureNum(val: string) {
    if (val) {
      const num = (val + "").replace(/,/g, "");
      return Number(num) <= 0;
    } else {
      return false;
    }
  }

  // 數字轉千分位 (number to string) ps.保留數字小數點至第二位
  private convertNumberToMoney(num: number) {
    if (!num) {
      return 0;
    }
    let a: string = (num + "").replace(/,/g, "");
    if (a.indexOf(".") != -1) {
      if (a.split(".")[1].length > 2) {
        a = Math.round(+a * 100) / 100 + "";
      }
      if (a.split(".").length == 2) {
        return (+a.split(".")[0]).toLocaleString() + "." + a.split(".")[1];
      } else {
        return (+a.split(".")[0]).toLocaleString();
      }
    } else {
      return (+a.split(".")[0]).toLocaleString();
    }
  }
}